import { render, staticRenderFns } from "./ImageTrivia.vue?vue&type=template&id=1b4b3157&scoped=true&"
import script from "./ImageTrivia.vue?vue&type=script&lang=js&"
export * from "./ImageTrivia.vue?vue&type=script&lang=js&"
import style0 from "./ImageTrivia.vue?vue&type=style&index=0&id=1b4b3157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b3157",
  null
  
)

export default component.exports